import { getContext, hasContext } from 'svelte';
export const getToasterContext = () => {
    if (hasContext('@significa/toast')) {
        return getContext('@significa/toast');
    }
};
